import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../styles/footer.css";
import SocialLinks from "./global/SocialLinks";

const FooterContent = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const date = new Date();

  return (
    <>
      <div className="footer -mt-1">
        <div className="container">
          <div className="footer-content">
            <div className="footer-content__item-1">
              <Link to="/">
                <img
                  src={require("../assets/images/logo-vrc.png")}
                  alt=""
                  className="footer__logo"
                />
              </Link>
              <p className="footer__descriptive-paragraph">
                The VR Voyage Classroom brings together institutions and experts
                from across the world to create an immersive and engaging
                learning experience for students.
              </p>
              <SocialLinks />
            </div>
            <ul className="list-pages footer-content__item-2">
              <h3 className="list-pages__title">menu</h3>
              <li>
                <Link to="/">Homepage</Link>
              </li>
              <li>
                <Link to="/the-platform">The Platform</Link>
              </li>
              <li>
                <Link to="/our-network">Our Network</Link>
              </li>
              <li>
                <Link to="/for-teachers">For Teachers</Link>
              </li>
              <li>
                <Link to="/for-partners">For Partners</Link>
              </li>
              {userInfo && (
                <li>
                  <Link to="/catalogue">Listings Catalogue</Link>
                </li>
              )}
              {userInfo &&
                (userInfo.type === "partner" || userInfo.type === "admin") && (
                  <>
                    <li>
                      <Link to="/partner-policy">Partner Policy</Link>
                    </li>
                    <li>
                      <Link to="/revenue-share">Partner Revenue Share</Link>
                    </li>
                  </>
                )}
              <li>
                <Link to="/privacy-policy">Legal</Link>
              </li>
            </ul>

            <div className="contact-section footer-content__item-3">
              <h4 className="contact-section__title">contact</h4>
              <div className="contact-section__list">
                <div className="contact-section__item">
                  <i
                    className="iconify contact-section__icon"
                    data-icon="bi:phone-fill"
                  />
                  <a href="tel:+12505694401">+1 250 569 4401</a>
                </div>
                <div className="contact-section__item">
                  <i
                    className="iconify contact-section__icon"
                    data-icon="ion:mail-outline"
                  />
                  <a href="mailto:vrvclassroom@foragereducation.com">
                    vrvclassroom@foragereducation.com
                  </a>
                </div>
                <div className="contact-section__item">
                  <i
                    className="iconify contact-section__icon"
                    data-icon="mdi:partnership-outline"
                  />
                  <a href="mailto:partners.ca@foragereducation.com">
                    partners.ca@foragereducation.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-image">
          <img
            className="image w-full"
            src={require("../assets/images/footer.png")}
            alt="footer"
          />
        </div>
        <hr />
        <div className="copyright container">
          <p>
            {`Copyright © ${date.getFullYear()}, forager group holdings ltd.`} 
          </p>
          <p className="copyright__create">
            website created by{" "}
            <span className="font-bold">
              forager | <span style={{ color: "#FF8329" }}>digital</span>
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default FooterContent;
